import { Roles } from "@/types/roles.type";
import { AcceptorRoutes } from "./acceptor.route";
import { AdminRoutes } from './admin.route';
import { ClientRoutes } from './client.route';
import { OpenRoutes } from "./open.route";
import { CommonRoutes } from "./common.route";
import { RouteRecordRaw } from "vue-router";

export const AllowedToRoute = (route: string): boolean => {
    if (OpenRoutes.find(element => element.name === route) != undefined ||
        CommonRoutes.children?.find(element => element.name === route) != undefined) {
        return true;
    }
    return false;
};

const routeSearch: Record<Roles, (route: string) => boolean> = {
    'ADMIN': (route: string): boolean => isRouteName(AdminRoutes, route),
    'OFFEROR': (route: string): boolean => isRouteName(ClientRoutes, route),
    'ACCEPTOR': (route: string): boolean => isRouteName(AcceptorRoutes, route),
    'NONE': (): boolean => false,
};

export const RoleAllowedToRoute = (role: Roles, route: string): boolean => {
    return routeSearch[role](route) ?? false;
};

export const AcceptorRoute = (route: string): boolean => {
    return routeSearch['ACCEPTOR'](route) ?? false;
};

const isRouteName = (route: RouteRecordRaw, routeName: string): boolean => {
    if (!route.children) {
        return route.name === routeName;
    }
    for (let index = 0; index < route.children.length; index++) {
        const child = route.children[index];
        if (isRouteName(child, routeName) === true) {
            return true;
        }
    }
    return false;
};